<template>
    <div v-if="notsubmitted" class="form-wrapper">
        <hr class="divider2">
        <div><h2 style="margin: 1.5vh 0;"  class="uk-text-center uk-text-bold">{{ title }}</h2></div>
        <form class="uk-form-stacked uk-form-width-meduim uk-padding uk-card">
            <p class="uk-text-lead uk-text-primary">Sign up for mobile and email updates!</p>
            <div class="uk-margin">
                <label style="text-align:left" class="uk-form-label" for="form-stacked-text">Phone</label>
                <div class="uk-form-controls">
                    <input
                        v-model="phone"
                        @change="interceptNonNumeric()"
                        class="uk-input"
                        id="form-stacked-text"
                        type="text"
                        placeholder="Enter phone: 8184445555">
                </div>
            </div>
            <button class="uk-button uk-button-small uk-margin-top uk-button-primary" type="submit" @click.prevent="submitPhone">Submit</button>
        </form>
    </div>
</template>

<script>
import ax from '../../store/apicall.js'
export default {
    data: function(){
        return {
            phone: "",
            errors:[],
            notsubmitted: true,
        }
    },
    props: ["title"],
    methods: {
        submitPhone(){
            this.interceptNonNumeric()
            ax.post('/accounts/profile/', {"phone":this.phone}).then(data => {
                console.log(data)
            }).catch(err => {
                this.errors.push(err)
            });
            this.notsubmitted = false;
        },
        interceptNonNumeric(){
            let disallowed = ['-','(',')','.']
            this.phone = [...this.phone].reduce((acc,cv) => {
                if(disallowed.indexOf(cv)){
                    acc+=cv;
                } else {
                    this.triggerWarning()
                }
                return acc;
            }, "")
        },
        triggerWarning(){
            console.warn('please dont enter special characters')
        },
    }

}
</script>

<style scoped>
    .form-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
    }
    form {
        transition: all 333ms;
        box-shadow: 0px 1px 5px #a9a9a9;
    }
    form:hover {
        transform: translateY(-5px);
        box-shadow: 0px 5px 15px #a9a9a9;
    }

    .divider2 {
        width: 74vw;
        border: 2px solid #d9d9d9;
        margin: 0px 100px;
    }
</style>
